import React from 'react'
import DepositAndWithdrawSection from '../../sections/DepositAndWithdrawSection'
import { LogosBannerSliceProps } from './types'

const LogosBannerSlice: React.FC<LogosBannerSliceProps> = ({ slice }) => (
  <DepositAndWithdrawSection
    inner="inners.primary"
    paddingTop={['38px', '', '90px']}
    paddingBottom={['0', '', '100px']}
    data={{
      list: (slice.items || []).map((item, index) => ({
        key: index,
        image: item?.logo
      }))
    }}
  />
)

export default LogosBannerSlice
